'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _About = require('./About.css');

var _About2 = _interopRequireDefault(_About);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var About = (_dec = (0, _reactCssModules2.default)(_About2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(About, _Component);

  function About(props) {
    (0, _classCallCheck3.default)(this, About);

    var _this = (0, _possibleConstructorReturn3.default)(this, (About.__proto__ || (0, _getPrototypeOf2.default)(About)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(About, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = 'About';
      var url = _config2.default.domain + _config2.default.routes.about;

      var bannerImage = 'park';
      var bannerHeadline = 'About Gun Free Funds';
      var bannerSubtitle = 'You can invest your values';

      // const aysLogo = require( '../../../static/images/' )
      var iyvLogo = require('../../../static/images/iyv-logo-project-of-2021.jpg');

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, '', url),
        _react2.default.createElement(
          'div',
          { styleName: 'image-banner' },
          _react2.default.createElement(
            'div',
            { styleName: 'image-banner-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'image-banner-container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'image-banner-' + bannerImage },
                _react2.default.createElement(
                  'div',
                  { styleName: 'image-banner-headline' },
                  bannerHeadline
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'image-banner-subtitle' },
                  bannerSubtitle
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(
            'div',
            { styleName: 'container' },
            _react2.default.createElement(
              'div',
              { styleName: 'container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'double-logo-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'double-logo' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'logo-second-wrap' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.links.aysinvest,
                        title: 'Invest Your Values - a project of As You Sow'
                      },
                      _react2.default.createElement('img', {
                        styleName: 'logo-ays',
                        src: iyvLogo,
                        alt: 'Invest Your Values - a project of As You Sow'
                      })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'title' },
                'You may be invested in gun manufacturers and gun retailers'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'lede' },
                'You shouldn\'t have to be a financial expert to know how much of your savings are invested in unsustainable and morally problematic companies.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'title' },
                'Responsible investing made easy'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'lede' },
                'Gun Free Funds enables you to find out if your money, in the form of individual mutual fund investments or an employer-provided 401(k), is being used to finance makers of assault rifles, handguns, shotguns, and other kinds of civilian firearms and ammunition, and to find alternative options that avoid gun investments.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'lede' },
                'We can help build a more peaceful world by reducing the power of those who profit from violence. Investors have the power to cut ties with the corporations that make and sell the tools of gun violence, and to reinvest in ethical companies that support our communities and protect our planet.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'title' },
                'Who we are'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'lede' },
                'For over two decades, As You Sow has promoted aligning investing with values. As part of our ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.links.aysinvest, xstrong: true, title: 'As You Sow - Invest Your Values' },
                  'Invest Your Values program'
                ),
                ', we\'ve created a series of tools that provide free information helping people align their investments with their values.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'title' },
                'How Gun Free Funds works'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'lede' },
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    'Look up mutual funds using up-to-date Morningstar data'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    'We analyze your investments for gun manufacturer and retailer stocks'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    'See each fund\'s gun investments grade'
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.routes.howitworks,
                      xstrong: true,
                      title: 'How it works' },
                    'See how it works',
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'title' },
                'Use our action toolkit'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'lede' },
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    'Learn how to make a change and invest gun free'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    'Push your employer to provide gun free 401(k) options'
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.routes.toolkit,
                      xstrong: true,
                      title: 'Action toolkit' },
                    'View the action toolkit',
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                )
              )
            )
          ),
          _react2.default.createElement(_components.GetStartedInput, null)
        )
      );
    }
  }]);
  return About;
}(_react.Component)) || _class);
exports.default = About;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/About/About.js
// module id = 1284
// module chunks = 0